import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useSelector } from "react-redux";

const AdminNotAllowRoute = ({ children }) => {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);

  useEffect(() => {
    if (session?.status === "authorized" && session?.user?.role === "admin") {
      navigate("/admin");
    }
  }, [session?.status, session?.user?.role, navigate]);

  if (session?.status === "loading") {
    return <LoadingFallback />;
  }

  return children;
};

export default AdminNotAllowRoute;
